// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_Rhbms","title":"index_title_n--NM","close":"index_close_znkYj","comment":"index_comment_J2Uvv"};